import Vue from 'vue';
import Vuex from 'vuex';
import Tracker from '@asayerio/tracker';
import trackerVuex from '@asayerio/tracker-vuex';
import api from '@/api';

let tracker = null;
if (process.env.NODE_ENV !== `development`) {
  tracker = new Tracker({
    projectID: 7282896072111201,
  });
  tracker.metadata(`module`, `ui-login`);
  tracker.start();
}

Vue.use(Vuex);

let plugins = [];
if (tracker) {
  plugins = [tracker.use(trackerVuex())];
}

export default {
  store: new Vuex.Store({
    state: () => ({
      me: null,
      alreadyLogged: null,
    }),
    mutations: {
      SET_ME (state, me) {
        state.me = me;
      },
      SET_ALREADY_LOGGED (state, already) {
        state.alreadyLogged = already;
      },
    },
    actions: {
      async login (context, { email, password }) {
        try {
          const { data } = await api.post(`/login`, { email, password });
          localStorage.setItem('jwt', data.token);
          localStorage.setItem('jwt.expiration', data.expiration);
          return true;
        } catch (e) {
          return false;
        }
      },
      async loginWithToken (context, token) {
        try {
          const { data } = await api.post(`/login-with-token/${token}`);
          localStorage.setItem('jwt', data.token);
          localStorage.setItem('jwt.expiration', data.expiration);
          return true;
        } catch (e) {
          return false;
        }
      },
      async initPassword (context, { token, password }) {
        try {
          const { data } = await api.put(`/users/init-password/${token}`, {
            password,
          });
          return data;
        } catch (e) {
          return false;
        }
      },
      async checkChangePassword (context, token) {
        try {
          await api.get(`/users/check-change-password/${token}`);
          return true;
        } catch (e) {
          return false;
        }
      },
      async resetPassword (context, email) {
        try {
          await api.post(`/users/init-password`, {
            email,
          });
          return true;
        } catch (e) {
          return false;
        }
      },
      async fetchMe ({ commit }) {
        try {
          const { data } = await api.get(`/me`, { headers: { Authorization : localStorage.getItem(`jwt`) } });
          commit(`SET_ME`, data);
          commit(`SET_ALREADY_LOGGED`, true);
        } catch (e) {
          commit (`SET_ALREADY_LOGGED`, false);
        }
      },
      async answerWithCode (context, code) {
        try {
          await api.get(`/surveys/validateParticipation/${code}`);
          return true;
        } catch (e) {
          return false;
        }
      },
    },
    plugins,
  }),
  tracker,
};
